import React, { FC } from 'react';
import { FunctionalComponentWithChildren } from '../../FCWithChildren';
const CloseIcon: FunctionalComponentWithChildren = props => {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 18L18 6M6 6L18 18"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export default CloseIcon;
